"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _FormContainersDnd = _interopRequireDefault(require("../../FormContainersDnd"));

var _reactGridLayout = _interopRequireDefault(require("react-grid-layout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ContainerDinamic = function ContainerDinamic(_ref) {
  var props = _ref.props;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      objectsForm = _useState2[0],
      setObjectsForm = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      itemProperties = _useState4[0],
      setItemProperties = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openProperties = _useState6[0],
      setOpenProperties = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      stateLoading = _useState8[0],
      setStateLoading = _useState8[1];

  var containerRef = /*#__PURE__*/(0, _react.createRef)();

  var handleItemSelected = function handleItemSelected(item, key) {
    console.log("handleItemSelected objectsForm: ", objectsForm);
    console.log("handleItemSelected item: ", item);
    console.log("handleItemSelected key: ", key);
    var objectsFormTmp = objectsForm.map(function (oForm) {
      var oF = oForm;
      oF.classes = "";

      if (oForm.i === key) {
        setItemProperties(oF);
        oF.classes = item.type === "radio" || item.type === "checkbox" ? "dnd-highlight-radio" : "dnd-highlight";
        setOpenProperties(true);
      }

      return oF;
    });
    setObjectsForm(objectsFormTmp);
  };

  var handleItemPropertiesChange = function handleItemPropertiesChange(layout) {
    console.log("handleItemPropertiesChange layout: ", layout);
    console.log("handleItemPropertiesChange objectsForm: ", objectsForm);
    var tmp = objectsForm.map(function (oForm, idx) {
      var oF = oForm;
      oF.classes = "";

      if (oForm.i === layout[idx].i) {
        oF.x = layout[idx].x;
        oF.y = layout[idx].y;
        oF.w = layout[idx].w;
        oF.h = layout[idx].h;
        oF.classes = "dnd-highlight";
      }

      return oF;
    });
    setObjectsForm(tmp);
  };

  var handleRemoveItem = function handleRemoveItem(item) {
    var selectParentId = null;

    if (item.type === "select") {
      selectParentId = item.i;
    } // eslint-disable-next-line array-callback-return


    var objectsFormTmp = objectsForm.filter(function (oForm) {
      if (oForm.i !== item.i) {
        var _oForm$isChild;

        var condition = (_oForm$isChild = oForm.isChild) !== null && _oForm$isChild !== void 0 && _oForm$isChild.parentId ? oForm.isChild.parentId : undefined;

        if (selectParentId !== condition) {
          return oForm;
        }
      }
    });
    setOpenProperties(false);
    setObjectsForm(objectsFormTmp);

    if (!objectsFormTmp.length) {
      setStateLoading(false);
    }
  };

  console.log("props: ", props);
  var layout = [
  /* { i: "a", x: 0, y: 0, w: 1, h: 2, static: true }, */
  {
    i: "a",
    x: 0,
    y: 0,
    w: 1,
    h: 2
  }, {
    i: "b",
    x: 1,
    y: 0,
    w: 3,
    h: 2,
    isDraggable: true
  },
  /* { i: "b", x: 1, y: 0, w: 3, h: 2, minW: 2, maxW: 4 }, */
  {
    i: "c",
    x: 4,
    y: 0,
    w: 1,
    h: 2,
    isBounded: true
  }];
  return /*#__PURE__*/React.createElement(_reactGridLayout.default, {
    className: "layout",
    layout: layout,
    cols: 12,
    rowHeight: 30,
    width: 1200
  }, /*#__PURE__*/React.createElement("div", {
    key: "a",
    style: {
      backgroundColor: "green"
    }
  }, "item 1"), /*#__PURE__*/React.createElement("div", {
    key: "b",
    style: {
      backgroundColor: "red"
    }
  }, "item 2"), /*#__PURE__*/React.createElement("div", {
    key: "c",
    style: {
      backgroundColor: "blue"
    }
  }, "item 3"));
  /* return (          
    <FormContainerDnd
        objectsForm={objectsForm}
        handleItemSelected={handleItemSelected}
        handleItemPropertiesChange={handleItemPropertiesChange}
        handleRemoveItem={handleRemoveItem}
        gridSize={2}
        container={containerRef}
        itemProperties={itemProperties}
    />
  ); */
};

var _default = ContainerDinamic;
exports.default = _default;